import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { mobile, tablet } from '@styles/global'
import Button from '@components/Button'
import { Xbox } from '@components/Svg'
import Input from '@components/Input'
import ChecklistQuestion from '@components/ChecklistQuestion'
import useTranslatedString from '@utils/useTranslatedString'
import useGlossary from '@utils/useGlossary'
import { useSiteState } from "@context/siteContext"
import isArabic from '@utils/isArabic'

const SlideContent = (props) => {
	const { slide, checklist, next, handleEmail, handleAnswer, handleLocation, handleGender, slides } = props
	const [agreed, setAgreed] = useState(false)
	const [email, setEmail] = useState(false)
	const [location, setLocation] = useState()
	const [gender, setGender] = useState()
	const [ siteState ] = useSiteState()
	const language = siteState?.checklistLanguage 
	

	const { checklistButtons } = useGlossary()

	const calcTime = numQuestions => {
		let t = Math.round(numQuestions / 5)
		return t > 0 ? t : 1
	}

	if(slide.type === 'welcome'){
		const trackingData = {
			event: 'custom.form.start',
			action: 'start',
			checklist: checklist.slug
		}
		return (
			<WelcomeSlide>
				{/* <Heading>Welcome</Heading> */}
				<h1 className='h3' dir={isArabic(useTranslatedString('title', 'slide1')) ? 'rtl' : 'ltr'}>{useTranslatedString('title', 'slide1')}</h1>
				<p dir={isArabic(useTranslatedString('text', 'slide1')) ? 'rtl' : 'ltr'}>{useTranslatedString('text', 'slide1')}</p>
				<ButtonWrap>
					<Button onClick={() => next(trackingData)} bgColor='bteal60' checklist>{useTranslatedString('buttonText', 'slide1')}</Button>
				</ButtonWrap>
			</WelcomeSlide>
		)
	} else if(slide.type === 'intro') {

		const trackingData = {
			event: 'custom.form.page.complete',
			action: 'page complete',
			type: slide.type,
			text: 'Ok, got it',
			section: {
				name: 'Intro',
				number: 1,
				total: 5
			},
			page: {
				number: slides?.findIndex(s => s.type === slide.type) + 1,
				numberTotal: slides?.length,
			},
			checklist: checklist?.slug,
		}

		return (
			<SlideInner>
				<Heading>{useTranslatedString('title', 'slide2')}</Heading>
				<MainText>
					
				</MainText>
				<SubText dir={isArabic(useTranslatedString('text', 'slide2')) ? 'rtl' : 'ltr'}>
					{useTranslatedString('text', 'slide2')}
				</SubText>
				<div>
					<Agree>
						<button onClick={() => setAgreed(!agreed)}>
							<Xbox checked={agreed}/>
						</button>
						<div dir={isArabic(useTranslatedString('agreeText', 'slide2')) ? 'rtl' : 'ltr'}>
							{useTranslatedString('agreeText', 'slide2')}<br/>
						</div>
					</Agree>
					<PPLink href='/privacy-policy' target="_blank" className='h5' dir={isArabic(useTranslatedString('agreeLinkText', 'slide2')) ? 'rtl' : 'ltr'}>{useTranslatedString('agreeLinkText', 'slide2')}</PPLink>
				</div>
				<AgreeButton onClick={() => next(trackingData)} bgColor='bteal60' agreed={agreed} checklist>{useTranslatedString('buttonText', 'slide2')}</AgreeButton>
			</SlideInner>
		)
	} else if(slide.type === 'index') {

		return (
			<SlideInner>
				<Heading>{useTranslatedString('subTitle', 'slide3')}</Heading>
				<MainText className='para' dir={isArabic(useTranslatedString('title', 'slide3')) ? 'rtl' : 'ltr'}>
					{useTranslatedString('title', 'slide3')}
				</MainText>
				<SubText dir={isArabic(useTranslatedString('text', 'slide3')) ? 'rtl' : 'ltr'}>
					{useTranslatedString('text', 'slide3')}
				</SubText>
				<ButtonWrap>
					{console.log({checklistButtons})}
					{checklistButtons?.map( button => 
						<Button internalLink={`/checklists/${button?.slug?.current}?lang=${[language]}`} bgColor='bteal60' checklist>{button.singularAudienceName?.hasOwnProperty(language) && button?.singularAudienceName[language] ? button?.singularAudienceName[language] : button?.singularAudienceName?.en}</Button>
					)}
				</ButtonWrap>
			</SlideInner>
		)
	} else if(slide.type === 'details') {

		const trackingData = {
			event: 'custom.form.page.complete',
			action: 'page complete',
			type: slide.type,
			text: 'Skip',
			section: {
				name: 'Intro',
				number: 1,
				total: 5
			},
			page: {
				number: slides?.findIndex(s => s.type === slide.type) + 1,
				numberTotal: slides?.length,
			},
			checklist: checklist?.slug,
		}

		return (
			<DetailsSlide>
				<Heading>Your Details</Heading>
				<h6>Email me my results</h6>
				<p>
					Having an email copy of your results can help you start a conversation with a health professional. PANDA will not store your contact information.
				</p>
				<EmailInput
					onChange={e => setEmail(e.target.value)}
					outline
					type="email"
					placeholder="Enter email"
					id="email"
					error={''}
				/>
				<Actions>
					<Button onClick={() => next(trackingData)} outline>{useTranslatedString('skip')} TEST</Button>
					<ContinueButton 
						onClick={() => handleEmail(email, {...trackingData, text: 'Email Results'})} 
						bgColor='dteal' 
						active={email.length && email.includes('@') && email.includes('.')}
					>
						Email Results
					</ContinueButton>
				</Actions>
			</DetailsSlide>
		)
	} else if(slide.type === 'sectionIntro') {
		const currentSection = slide.sections.find(section => section.title === slide.section)
		const currentSectionIndex = slide.sections.findIndex(section => section.title === slide.section)
		// console.log({slide})
		const trackingData = {
			event: 'custom.form.page.complete',
			action: 'page complete',
			type: slide.type,
			text: 'Begin Section',
			section: {
				name: currentSection.title,
				number: currentSectionIndex + 2,
				total: 5
			},
			question:{
				totalsection: currentSection?.questions?.length,
				total: slide.sections.map(section => section.questions)?.flat()?.length
			},
			page: {
				number: slides?.findIndex(s => s.type === slide.type && s.section === slide.section) + 1,
				numberTotal: slides?.length,
			},
			checklist: checklist?.slug,
			language,
		}
		return (
			<SlideInner>
				{language === 'en' &&
					<Heading>Section {currentSectionIndex + 1} of {slide.sections?.length}</Heading>
				}
				<SectionTitle>
					{slide.section}
				</SectionTitle>
				<p>{slide.subtitle}</p>
				{language === 'en' &&
					<SubHeading className="b2">Estimated {calcTime(currentSection.questions?.length)} minute{calcTime(currentSection.questions?.length) === 1 ? '' : 's'} to complete</SubHeading>
				}
				<NextButton active onClick={() => next(trackingData)} bgColor='bteal60' agreed={agreed} checklist>{currentSectionIndex === 0 ? useTranslatedString('begin') : useTranslatedString('continue')}</NextButton>
			</SlideInner>
		)
	} else if(slide.type === 'question') {
		return (
			<ChecklistQuestion {...props} key={slide.question} />
		)
	} else {
		return null
	}
}

const ChecklistSlide = (props) => {
	return (
		<Wrap className={props.className}>
			<SlideContent {...props} />
		</Wrap>
	)
}

export const Heading = styled.h5`
	color: var(--xdbeige);
	margin-bottom: var(--s);
`

const SubHeading = styled.p`
	color: var(--teal);
	margin-top: -1rem;
	margin-bottom: var(--m);
`

const Wrap = styled.div`
	background: var(--white);
	min-height: 40vh;
	max-width: 818px;
	width: 100%;
	padding: 0 var(--s);
	box-sizing: border-box;
	border-radius: 4px;
`

export const SlideInner = styled.div`
	text-align: center;
	padding: var(--m);
	padding-bottom: var(--xxl);
	p {
		max-width: 580px;
		margin-left: auto;
		margin-right: auto;
	}
	h4{
		margin-bottom: var(--xs);
	}
	h3{
		margin-bottom: var(--xs);
	}
	${mobile}{
		padding: var(--m) 0;
	}
`

const MainText = styled.p`
	min-height: 1rem;
	margin-bottom: 0.5em;
`

const SubText = styled.p`
	
`

const ButtonWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 10px;
	margin-top: var(--xxl);
`

export const NextButton = styled(Button)`
	margin-top: var(--m);
	pointer-events: ${props => props.active ? 'all' : 'none'};
	opacity: ${props => props.active ? '1' : '0.3'};
`

const WelcomeSlide = styled(SlideInner)`
	text-align: center;
	padding: var(--m);
	> .h5{
		color: var(--teal);
		margin-bottom: var(--xs);
	}
	> .h3{
		margin-bottom: var(--m);
	}
	p{
		margin-left: auto;
		margin-right: auto;
		max-width: 600px;
	}
	span {
		display: inline;
		border-bottom: 3px solid var(--bteal);
	}
`

const DetailsSlide = styled(SlideInner)`
	h6{
		margin-bottom: var(--m);
	}
	.input {
		display: block;
		max-width: 400px;
		margin: var(--l) auto;

	}
`

const EmailInput = styled(Input)`
	display: block;
`

const ContinueButton = styled(Button)`
	pointer-events: ${props => props.active ? 'all' : 'none'};
	opacity: ${props => props.active ? '1' : '0.3'};
`

const Actions = styled.div`
	> * {
		margin: 0 var(--xxs);
		${mobile}{
			margin: 0;
		}
		&:first-child{
			margin-bottom: var(--xs);
		}
	}
`

const Agree = styled.h5`
	display: flex;
	justify-content: center;
	margin: var(--xxxl) auto var(--xxs);
	text-align: left;
	align-items: center;
	svg {
		display: block;
		margin-right: var(--xs);
	}
	a{
		text-decoration: underline;
		color: var(--bteal60)
	}
	> div {
		${mobile}{
			max-width: 180px;
		}
	}
`

const PPLink = styled.a`
	text-decoration: underline;
	display: inline-block;
	color: var(--bteal60);
	text-underline-offset: 0.2em;
	margin-bottom: var(--m);
`

const AgreeButton = styled(Button)`
	pointer-events: ${props => props.agreed ? 'all' : 'none'};
	opacity: ${props => props.agreed ? '1' : '0.5'};
`

const SectionTitle = styled.h3`
	color: ${props => props.active ? 'var(--bteal)' : 'inherit'};
	padding: 1em 0 0.5em;
`

const Locations = styled.div`
	
`

const Answer = styled.button`
	border: 0px solid var(--dteal);
	min-width: 6em;
	display: inline-block;
	margin: 0 1em;
	padding: var(--xs);
	background: ${props => props.inverse ? 'var(--white)' : 'var(--bteal60)'};
	border: ${props => props.inverse ? '3px solid var(--dteal)' : 'var(--bteal60)'};
	color: ${props => props.active ? 'var(--white)' : 'inherit'};
	box-sizing: border-box;
	/* margin-left: -3px; */
	margin-bottom: 1em;
	border-radius: 4px;
	${mobile}{
		/* border: 0px solid var(--dteal); */
		&:last-child{
			/* border-bottom: 0px solid var(--dteal); */
		}
	}
`

SlideContent.propTypes = {
	slide: PropTypes.object,
	checklist: PropTypes.object,
	next: PropTypes.func,
	slides: PropTypes.array,
}

ChecklistSlide.propTypes = {
	className: PropTypes.string,
	slide: PropTypes.object,
	checklist: PropTypes.object,
	next: PropTypes.func,
}

export default ChecklistSlide